<div class="login-shell">
  <div class="login-shell-overlay"></div>

  <div class="login-wrapper">
    <form class="login-form" [formGroup]="form" (ngSubmit)="login()">
      <mat-card class="login-card">
        <div class="login-grid">
          <section class="brand-panel">
            <div class="brand-content">
              <img [src]="logo()" alt="Logomarca da empresa" class="company-logo">
<!--              <span class="brand-kicker">Self Storage com acesso simples e seguro</span>-->
              <h1>Seu box sempre ao seu alcance.</h1>
              <p>
                Acompanhe seus contratos, cobranças e informações do seu box de self storage em um só lugar.
              </p>
            </div>
          </section>

          <section class="form-panel">
            <div class="form-header">
              <h2>Área do Cliente</h2>
              <p>Acesse seus contratos, cobranças e informações do seu box.</p>
            </div>

            <div class="form-fields">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Login</mat-label>
                <mat-icon matPrefix>person</mat-icon>
                <input
                  matInput
                  type="text"
                  formControlName="login"
                  autocomplete="username"
                  placeholder="Digite seu E-mail, CPF ou CNPJ">
                <mat-error *ngIf="form.get('login')?.hasError('required')">
                  Campo obrigatório
                </mat-error>
                <mat-hint>CPF, CNPJ ou e-mail</mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Senha</mat-label>
                <mat-icon matPrefix>lock</mat-icon>
                <input
                  matInput
                  [type]="hidePassword ? 'password' : 'text'"
                  formControlName="password"
                  autocomplete="current-password"
                  placeholder="Digite sua senha">
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  (click)="hidePassword = !hidePassword"
                  [attr.aria-label]="'Mostrar senha'"
                  [attr.aria-pressed]="!hidePassword">
                  <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                <mat-error *ngIf="form.get('password')?.hasError('required')">
                  Senha é obrigatória
                </mat-error>
              </mat-form-field>
            </div>

            <div class="login-actions">
              <button
                mat-raised-button
                color="primary"
                type="submit"
                [disabled]="!form.valid || isLoading"
                class="login-button">
                <mat-icon *ngIf="isLoading">hourglass_empty</mat-icon>
                <span>{{ isLoading ? 'Entrando...' : 'Entrar' }}</span>
              </button>

              <a
                mat-button
                [routerLink]="['/forgot-password']"
                class="forgot-password-link">
                Esqueci minha senha
              </a>
            </div>
          </section>
        </div>

        <footer class="login-footer">
          <p>
            Desenvolvido pela
            <a href="https://cdsistemas.com.br" target="_blank" rel="noopener noreferrer">C&amp;D Sistemas</a>
          </p>
          <span>Versão {{ systemInfo.lastBuildNumber }} - {{ systemInfo.lastBuildDate | date:'dd/MM/yyyy' }}</span>
        </footer>
      </mat-card>
    </form>
  </div>

  <ngx-spinner></ngx-spinner>
</div>
